module.exports = __webpack_public_path__ + "static/media/got-some-part.94425b5b.txt";